/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable, OnInit } from '@angular/core';

import { AbstractFormComponent, AelNavigationParams, FormFlowState } from '@gh/builder-shared';
import { ActionFlow, FormStateSnapshot } from '@gh/common-shared';

import { ScheduleDetails, ScheduleMasterInfo, ScheduleTask } from '../../resources/schedule-details.model';
import { ScheduleDetailsCommandService, ScheduleDetailsComponent } from './schedule-details-command.service';

export abstract class AbstractScheduleDetailsComponent extends AbstractFormComponent<ScheduleDetails>
  implements OnInit, ScheduleDetailsComponent {
  abstract baseRoutePath: string;

  constructor(private commands: ScheduleDetailsCommandService) {
    super();
  }

  get completeFlow(): ActionFlow<FormFlowState<ScheduleDetails>> {
    return this.commands.completeFlow;
  }

  // tslint:disable-next-line:contextual-lifecycle
  ngOnInit(): void {
    this.commands.init(this);
  }

  onMasterInfoChange(snapshot: FormStateSnapshot<ScheduleMasterInfo>): void {
    this.commands.setMasterInfo(snapshot);
  }

  onTaskSetField(task: ScheduleTask, field: string, value: any): void {
    this.commands.setTaskField(task, field, value);
  }

  onTaskRemove(task: ScheduleTask): void {
    this.commands.removeTask(task);
  }

  onTaskOpen(task: ScheduleTask): void {
    this.commands.openTask(task);
  }

  onSaveBaseDates(): void {
    this.commands.saveBaseDates();
  }

  onShowBaseDatesChange(show: boolean): void {
    this.commands.showBaseDatesChange(show);
  }

  onOpenGanttChart(): void {
    this.commands.openGanttChart();
  }

  onOpenReport(): void {
    this.commands.openReport();
  }

  goToAel(): void {
    this.commands.goToAel();
  }

  abstract buildAelNavigationParams(): AelNavigationParams;
}
